export type SelectKey = `folder:${string}` | `doc:${string}`;

export function folderKey(id: string): SelectKey {
  return `folder:${id}`;
}

export function docKey(id: string): SelectKey {
  return `doc:${id}`;
}

export function parseSelectKey(key: SelectKey): { kind: "folder" | "doc"; id: string } {
  if (key.startsWith("folder:")) return { kind: "folder", id: key.slice(7) };
  return { kind: "doc", id: key.slice(4) };
}

export function toggleKey(set: Set<SelectKey>, key: SelectKey, on?: boolean): Set<SelectKey> {
  const next = new Set(set);
  const shouldAdd = on ?? !next.has(key);
  if (shouldAdd) next.add(key);
  else next.delete(key);
  return next;
}

export function selectAllKeys(current: Set<SelectKey>, keys: SelectKey[], on: boolean): Set<SelectKey> {
  const next = new Set(current);
  for (const key of keys) {
    if (on) next.add(key);
    else next.delete(key);
  }
  return next;
}

export type FolderPath = { id: string; path: string };

/** True when target is the folder itself or nested under it. */
export function folderContainsTarget(folder: FolderPath, targetId: string | null, folders: FolderPath[]): boolean {
  if (!targetId) return false;
  const target = folders.find((f) => f.id === targetId);
  if (!target) return false;
  return target.id === folder.id || target.path.startsWith(`${folder.path}/`);
}

/** Sort folders deepest-first so parent moves happen after children. */
export function foldersByDepth<T extends FolderPath>(rows: T[]): T[] {
  return [...rows].sort((a, b) => b.path.split("/").length - a.path.split("/").length);
}
